import { Check, Circle, ShieldCheck } from 'lucide-react';
import { PASSWORD_RULES } from '@/lib/passwordPolicy';

export function PasswordRules({ password, testId = 'password-rules' }) {
  const pwd = password || '';
  return (
    <ul className="mt-2 space-y-1 text-[11px]" data-testid={testId}>
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(pwd);
        return (
          <li
            key={r.id}
            className={`flex items-center gap-1.5 transition-colors ${ok ? 'text-emerald-500' : 'text-muted-foreground'}`}
            data-testid={`${testId}-${r.id}`}
            data-met={ok ? 'true' : 'false'}
          >
            {ok ? <Check className="w-3 h-3 shrink-0" /> : <Circle className="w-3 h-3 shrink-0" />}
            {r.label}
          </li>
        );
      })}
      <li className="flex items-center gap-1.5 text-muted-foreground" data-testid={`${testId}-breach`}>
        <ShieldCheck className="w-3 h-3 shrink-0" />
        Not found in known data breaches (checked when you save)
      </li>
    </ul>
  );
}

export default PasswordRules;
